import { createSlice, PayloadAction, Slice, CaseReducerActions, SliceCaseReducers, AnyAction } from '@reduxjs/toolkit';
import { Reducer } from 'react';
import { RootState, AppThunk } from '.';
import { IBudgetService, BudgetService } from '../services/proyecta/budget.service';
import { Utilities } from '@utils';
import { ICmdBasicDataProjectBudget, ICmdTableBudgetByProject, ICmdTableBudgetFFCC, ICmdTableBudgetFFRR } from '@models/*';

export interface IBudgetState {
    formMasters: any;
    basicDataColumns: any;
    detailDataColumns: any;
    projectNumber?: any;
    projectCode?: any;
    basicBudgets?: any[];
    expandBudgets?: any[];
    budget?: any;
    currentBudget?: any;
    formBudgetByProjectTableColumnDefinition: any;
    formBudgetTablesFFCCColumnDefinition: any;
    currentFFCCFormTable?: any;
    currentByProjectTable?: any;
    currentFFRRFormTable?: any;
    codeProject?: any;
    budgetStatus?: any;
    formSaveBudget?: any;
    formSavingBudget?: any;
}

export class BudgetStore {
    COMPLETE_TASK_DISPATCH = "session/addCompleteThread";

    reducer: Reducer<any, AnyAction>;
    service: IBudgetService;
    initialState: IBudgetState;
    slice: Slice;
    actions: CaseReducerActions<SliceCaseReducers<any>>;

    //declare selectors
    selectbudgetStatus: any
    selectFormMasters: any;
    selectBasicDataColumns: any;
    selectDetailDataColumns: any;
    selectCurrentBudget: any;
    selectcodeProject: any;
    selectBasicBudgets: any;
    selectProjectNumber: any;
    selectFormBudgetByProjectTableColumnDefinition: any;
    selectFormBudgetTablesFFCCColumnDefinition: any;
    selectFormTableByProject: any;
    selectFormTableFFCC: any;
    selectFormTableFFRR: any;
    selectExpandBudgets: any;
    selectFormSaveBudget: any;
    selectFormSavingBudget: any;

    constructor() {
        this.service = new BudgetService();
        this.initialState = {
            formMasters: null,
            basicDataColumns: null,
            detailDataColumns: null,
            basicBudgets: null,
            expandBudgets: null,
            codeProject: null,
            projectNumber: null,
            formBudgetByProjectTableColumnDefinition: null,
            formBudgetTablesFFCCColumnDefinition: null,
            budgetStatus: {}
        };
        this.slice = createSlice({
            name: 'budget',
            initialState: this.initialState,
            reducers: {
                getAllFormMasters: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.formMasters = action.payload;
                },
                getBudgetBasicDataColumns: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.basicDataColumns = action.payload;
                },
                getBudgetDetailColumns: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.detailDataColumns = action.payload;
                },
                getProjectNumber: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.projectNumber = action.payload;
                },
                getBasicBudgets: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.basicBudgets = action.payload;
                },
                getExpandBudgets: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.expandBudgets = action.payload;
                },
                getBudget: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.budget = action.payload;
                },
                saveBudget: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.budget = action.payload;
                },
                updateBudget: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.budget = action.payload;
                },
                setCurrentBudget: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.currentBudget = action.payload;
                },
                getCodeProject: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.codeProject = action.payload;
                },
                getBudgetTableBudgetByProjectColumnsDefinitions: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.formBudgetByProjectTableColumnDefinition = action.payload;
                },
                getFormBudgetTablesFFCCColumnDefinition: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.formBudgetTablesFFCCColumnDefinition = action.payload;
                },
                getProjectByGrantCodeId: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.formMasters.projects = action.payload;
                },
                setCurrentFFCCTableToStore: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.currentFFCCFormTable = action.payload;
                },
                setCurrentTableByProjectStore: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.currentByProjectTable = action.payload;
                },
                setCurrentFFRRTableToStore: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.currentFFRRFormTable = action.payload;
                },
                setBudgetStatus: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.budgetStatus = action.payload;
                },
                getFormSaveBudget: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.formSaveBudget = action.payload;
                },
                setFormSavingBudget: (state: IBudgetState, action: PayloadAction<any>) => {
                    state.formSavingBudget = action.payload;
                }
            }
        });

        //create properties to context - redux actions & redux reducer
        this.actions = this.slice.actions;
        this.reducer = this.slice.reducer;

        //initialize selectors
        this.selectFormMasters = (state: RootState) => state.budget.formMasters;
        this.selectBasicDataColumns = (state: RootState) => state.budget.basicDataColumns;
        this.selectDetailDataColumns = (state: RootState) => state.budget.detailDataColumns;
        this.selectCurrentBudget = (state: RootState) => state.budget.currentBudget;
        this.selectBasicBudgets = (state: RootState) => state.budget.basicBudgets;
        this.selectProjectNumber = (state: RootState) => state.budget.projectNumber;
        this.selectFormBudgetByProjectTableColumnDefinition = (state: RootState) => state.budget.formBudgetByProjectTableColumnDefinition;
        this.selectFormBudgetTablesFFCCColumnDefinition = (state: RootState) => state.budget.formBudgetTablesFFCCColumnDefinition;
        this.selectFormTableByProject = (state: RootState) => state.budget.currentByProjectTable;
        this.selectFormTableFFCC = (state: RootState) => state.budget.currentFFCCFormTable;
        this.selectFormTableFFRR = (state: RootState) => state.budget.currentFFRRFormTable;
        this.selectExpandBudgets = (state: RootState) => state.budget.expandBudgets;
        this.selectcodeProject = (state: RootState) => state.budget.codeProject;
        this.selectbudgetStatus = (state: RootState) => state.budget.budgetStatus;
        this.selectFormSaveBudget = (state: RootState) => state.budget.formSaveBudget;
        this.selectFormSavingBudget = (state: RootState) => state.budget.formSavingBudget;
    }

    public getAllFormMasters = (): AppThunk => (dispatch, getState) => {
        const lang = getState().session.lang;
        if (!Utilities.isNullObject(lang)) {
            this.service.getAllFormMasters(lang.label)
                .then((formMaster: any) => {
                    dispatch(this.actions.getAllFormMasters(formMaster));
                    dispatch({ type: this.COMPLETE_TASK_DISPATCH });
                })
                .catch(err => Utilities.writeInConsoleLog(err));
        }
    }
    public getBudgetBasicDataColumns = (): AppThunk => (dispatch, getState) => {
        const lang = getState().session.lang;
        if (!Utilities.isNullObject(lang)) {
            this.service.getBudgetBasicDataColumns(lang.id)
                .then((basicDataColumns: any) => {
                    dispatch(this.actions.getBudgetBasicDataColumns(basicDataColumns))
                    dispatch({ type: this.COMPLETE_TASK_DISPATCH });
                })
                .catch(err => Utilities.writeInConsoleLog(err));
        }
    }
    public getBudgetDetailColumns = (): AppThunk => (dispatch, getState) => {
        const lang = getState().session.lang;
        if (!Utilities.isNullObject(lang)) {
            this.service.getBudgetDetailColumns(lang.id)
                .then((detailDataColumns: any) => {
                    dispatch(this.actions.getBudgetDetailColumns(detailDataColumns));
                    dispatch({ type: this.COMPLETE_TASK_DISPATCH });
                })
                .catch(err => Utilities.writeInConsoleLog(err));
        }
    }
    public getProjectNumber = (title?: string): AppThunk => (dispatch) => {
        this.service.getProjectNumber(title)
            .then((projectNumber: any) => {
                //forze change;
                dispatch(this.actions.getProjectNumber(null));
                dispatch(this.actions.getProjectNumber(projectNumber));
                dispatch({ type: this.COMPLETE_TASK_DISPATCH });
            })
            .catch(err => Utilities.writeInConsoleLog(err));
    }
    // Optener lista de tipo de presupuestos.
    public getBasicBudgets = (filter: boolean = true): AppThunk => (dispatch) => {
        this.service.getBasicBudgets(filter)
            .then((budgets: any[]) => {
                dispatch(this.actions.getBasicBudgets(budgets));
                dispatch({ type: this.COMPLETE_TASK_DISPATCH });
            })
            .catch(err => Utilities.writeInConsoleLog(err));
    }

    public getExpandBudgets = (): AppThunk => (dispatch) => {
        this.service.getExpandBudgets()
            .then((budgets: any[]) => {
                dispatch(this.actions.getExpandBudgets(budgets));
                dispatch({ type: this.COMPLETE_TASK_DISPATCH });
            })
            .catch(err => Utilities.writeInConsoleLog(err));
    }
    public getBudget = (budgetId?: number): AppThunk => (dispatch) => {
        this.service.getBudgetAndDetails(budgetId)
            .then((budget: any) => {
                dispatch(this.actions.setCurrentBudget(budget.currentBudget))
                //Table by project
                dispatch(this.actions.setCurrentTableByProjectStore(budget.tableByProject));
                //Table by FFCC
                dispatch(this.actions.setCurrentFFCCTableToStore(budget.tableFFCC));
                //Table by FFRR
                dispatch(this.actions.setCurrentFFRRTableToStore(budget.tableFFRR));
                dispatch({ type: this.COMPLETE_TASK_DISPATCH });
            })
            .catch(err => Utilities.writeInConsoleLog(err));
    }

    public resetCurrentBudget = (): AppThunk => (dispatch) => {
        dispatch(this.actions.setCurrentBudget(null))
        //Table by project
        dispatch(this.actions.setCurrentTableByProjectStore(null));
        //Table by FFCC
        dispatch(this.actions.setCurrentFFCCTableToStore(null));
        //Table by FFRR
        dispatch(this.actions.setCurrentFFRRTableToStore(null));
        dispatch({ type: this.COMPLETE_TASK_DISPATCH });
    }

    public setBudgetStatus = (body: any): AppThunk => (dispatch, getState) => {
        dispatch(this.actions.setBudgetStatus(body));
        dispatch({ type: 'session/addCompleteThread' });
    }

    public getFormBudgetByProjectTablesColumnDefinition = (): AppThunk => (dispatch, getState) => {
        const lang = getState().session.lang;
        if (!Utilities.isNullObject(lang)) {
            this.service.getFormBudgetTablesColumnDefinition(lang.id)
                .then((detailDataColumns: any) => {
                    dispatch(this.actions.getBudgetTableBudgetByProjectColumnsDefinitions(detailDataColumns));
                    dispatch({ type: this.COMPLETE_TASK_DISPATCH });
                })
                .catch(err => {
                    Utilities.writeInConsoleLog(err);
                    dispatch({ type: this.COMPLETE_TASK_DISPATCH });
                });
        }
    }

    public getFormBudgetTablesFFCCColumnDefinition = (): AppThunk => (dispatch, getState) => {
        const lang = getState().session.lang;
        if (!Utilities.isNullObject(lang)) {
            this.service.getFormBudgetTablesFFCCColumnDefinition(lang.id)
                .then((detailDataColumns: any) => {
                    dispatch(this.actions.getFormBudgetTablesFFCCColumnDefinition(detailDataColumns));
                    dispatch({ type: this.COMPLETE_TASK_DISPATCH });
                })
                .catch(err => {
                    Utilities.writeInConsoleLog(err);
                    dispatch({ type: this.COMPLETE_TASK_DISPATCH });
                });
        }
    }

    public getProjectByGrantCodeId = (grantCodeId: number): AppThunk => (dispatch, getState) => {
        this.service.getProjectByGrantCodeId(grantCodeId)
            .then((projects: any) => {
                dispatch(this.actions.getProjectByGrantCodeId(projects))
                dispatch({ type: this.COMPLETE_TASK_DISPATCH });
            })
            .catch(err => {
                Utilities.writeInConsoleLog(err);
                dispatch({ type: this.COMPLETE_TASK_DISPATCH });
            });
    }

    public setSavingFormBudget = (savingForm: boolean): AppThunk => (dispatch, getState) => {
        dispatch(this.actions.setFormSavingBudget(savingForm));
        dispatch({ type: this.COMPLETE_TASK_DISPATCH });
    }
} 
